module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0742e_banner_800x600.09e485d3.png";